export const onboardingApiHandler = {
  getProgress: {
    method: "GET",
    path: (payload: { orgId: number | string }) => `admin-dashboard/organizations/${payload.orgId}/onboarding/progress`,
    params: {} as {'status'?: 'NOT_STARTED' | 'IN_PROGRESS' | 'COMPLETE'}
  },
  getUserProgress: {
    method: "GET",
    // Same endpoint as getProgress — the backend only registers @Get('progress');
    // the per-user drill-down is the same route with ?userId= as a query param,
    // not a path segment (there is no .../progress/:userId route).
    path: (payload: { orgId: number | string }) => `admin-dashboard/organizations/${payload.orgId}/onboarding/progress`,
    params: {} as { userId: number | string }
  },
  // Lite step editor — CRUD + reorder over the onboarding journey's steps.
  getSteps: {
    method: "GET",
    path: (payload: { orgId: number | string }) => `admin-dashboard/organizations/${payload.orgId}/onboarding/steps`
  },
  createStep: {
    method: "POST",
    path: (payload: { orgId: number | string }) => `admin-dashboard/organizations/${payload.orgId}/onboarding/steps`
  },
  updateStep: {
    method: "PATCH",
    path: (payload: { orgId: number | string; stepId: number | string }) => `admin-dashboard/organizations/${payload.orgId}/onboarding/steps/${payload.stepId}`
  },
  reorderSteps: {
    method: "PUT",
    path: (payload: { orgId: number | string }) => `admin-dashboard/organizations/${payload.orgId}/onboarding/steps/reorder`
  },
  // Soft-disable. Not wired into the UI (no delete button — destructive UI
  // deferred per decision); the active toggle uses updateStep/PATCH in both
  // directions instead since DELETE only sensibly maps to "disable", not
  // "re-enable". Kept here since it's part of the backend contract.
  disableStep: {
    method: "DELETE",
    path: (payload: { orgId: number | string; stepId: number | string }) => `admin-dashboard/organizations/${payload.orgId}/onboarding/steps/${payload.stepId}`
  },
  // KP-63 graded assessments — admin-only assessment listing that INCLUDES
  // each option's isCorrect answer key (the shared student options endpoint
  // deliberately never exposes it), plus the wholesale answer-key replace.
  getAssessments: {
    method: "GET",
    path: (payload: { orgId: number | string }) => `admin-dashboard/organizations/${payload.orgId}/onboarding/assessments`
  },
  setCorrectOptions: {
    method: "PUT",
    path: (payload: { orgId: number | string; assessmentId: number | string }) => `admin-dashboard/organizations/${payload.orgId}/onboarding/assessments/${payload.assessmentId}/correct-options`
  }
};
